// https://vuex.vuejs.org/en/getters.html
export default {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  hasOpenInvoice(state){
    return state.hasOpenInvoice
  },
  errors(state) {
    return state.errors;
  },
  message(state) {
    return state.message;
  },
  loading(state) {
    return state.loading;
  },
  price(state){
    return state.price;
  },
  credit(state){
    return state.credit;
  },
  client(state) {
    return state.client;
  },
  address(state) {
    return state.address;
  },
};
